import { FC, useEffect, useState } from 'react';
import styles from './search-header.module.scss';
import Button from 'components/atoms/button/button';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import useDebounce from 'custom-hooks/useDebounce';
import { WCircularProgress } from 'components/wrappers/wrapper';

interface SearchHeaderProps {
  value: string;
  debounce?: number;
  loading?: boolean;
  onChange: (value: string) => void;
  onClose: () => void;
}

const SearchHeader: FC<SearchHeaderProps> = ({
  value,
  debounce = 0,
  loading,
  onChange,
  onClose,
}) => {
  const [inputValue, setInputValue] = useState(value);
  const debouncedValue = useDebounce(inputValue, debounce);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  useEffect(() => {
    onChange(debouncedValue);
  }, [debouncedValue]);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  return (
    <div className={styles.header}>
      {loading ? <WCircularProgress size={20} /> : <SearchIcon className={styles.search} />}
      <input value={inputValue} placeholder="Search here..." onChange={handleChange} />
      <Button type="base" onClick={onClose}>
        <CloseIcon  style={{color:"white"}} fontSize="small" />
      </Button>
    </div>
  );
};
export default SearchHeader;
